import _ from "lodash";

export default {
  data() {
    return {
      searchInput: "",
      search: ""
    };
  },
  watch: {
    searchInput: _.debounce(function(newVal) {
      this.search = newVal;
      this.fetchItems();
    }, 300)
  }
};
